import toast from 'react-hot-toast'

/**
 * 
 * @param {String} message 
 * @param {import('react-hot-toast').ToastOptions} options 
 * @returns {String}
 */
export const successToast = (message, options = {}) => {
    return toast.success(message, options)
}

/**
 * 
 * @param {String} message 
 * @param {import('react-hot-toast').ToastOptions} options 
 * @returns {String}
 */
export const errorToast = (message, options = {}) => {
    return toast.error(message, options)
}

export const dismissAllToast = () => {
    toast.dismiss()
}

export const dismissToast = (toastId) => {
    toast.dismiss(toastId)
}